<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame">
<p class="structure-next"><span><img alt="IllustrationContent-24.png" class="frame1" src="OEBPS/image/IllustrationContent-24_fmt.png"/></span> </p>
<p class="chap"> </p>
<p class="chap">I Got A Useless Degree…Now What?//</p>
<p class="chap"><a id="b3"></a><a href="#/OEBPS/NGJobHacks_split_004#a3">How to Turn Your Miscellaneous Degree into a Career</a></p>
<div class="calibre1" id="calibre_pb_8"></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// NGJobHacks_split_008.vue?b1efde92